module.exports = __webpack_public_path__ + "img/pro_two_3.168a9322.jpg";